// extracted by mini-css-extract-plugin
module.exports = {"preview":"PostMainImagePreview_preview___hk47","preview_hide":"PostMainImagePreview_preview_hide__2iXYx"};